import React from 'react';
import PropTypes from 'prop-types';

function Hero({ page, headerStyle, wedding, handleScroll }) {
  return (
    <div className="hero-wrapper">
      <div className={`jumbotron home-page-hero ${page.header_image_url ? 'has-image' : 'no-image'}`} style={headerStyle}>
        {window.zola.env !== 'production' ? (
          <span role="img" aria-label={`The Wedding Website of ${wedding.owner_first_name} ${wedding.owner_last_name} and ${wedding.partner_first_name} ${wedding.partner_last_name}`} />
        ) : (
          null
        )}
        <div className="hero-accent-top-left" />
        <div className="hero-accent-top-right" />
        <div className="hero-accent-bottom-left" />
        <div className="hero-accent-bottom-right" />
        <div className="homepage-header-text">
          <h1>{page && page.title}</h1>
        </div>
        <div className="down-arrow">
          <i className="zolaicon-public zolaicon-public-chevron-down" onClick={handleScroll} role="button" />
        </div>
      </div>
    </div>
  );
}

Hero.propTypes = {
  headerStyle: PropTypes.shape({}),
  wedding: PropTypes.shape({}).isRequired,
  page: PropTypes.shape({}),
  handleScroll: PropTypes.func.isRequired
};

export default Hero;



// WEBPACK FOOTER //
// ./src/components/PublicWebsite/pages/Home/Hero.jsx